let locales = {
    changePAState_nextState: 'Siguiente estado',
    changePAState_state: 'Estado',
    changePAState_note: 'Texto de la nota',
    changePAState_date: 'Fecha de la nota',
    changePAState_rememberChanges: 'Recuerde que la nota es obligatoria para cambios de estado',
    changePAState_noteMessage: '¿Seguro que quieres enviar esta nota?',
};

export default locales;